module.exports = __webpack_public_path__ + "images/assessment_correct.svg";